import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Icon from "components/Icon";
import PrivateGameError from "./PrivateCode";
import NotFound from "pages/NotFound";
import { notificationsTypes } from "domain/Notifications/types";

class GameError extends React.Component {
    componentDidMount = () => {
        const { unreadNotifications, setNotificationsAsViewed } = this.props;

        if (
            Array.isArray(unreadNotifications) &&
            unreadNotifications.length > 0
        ) {
            setNotificationsAsViewed(
                unreadNotifications.map((item) => item.id)
            );
        }
    };

    render = () => {
        const { errorDesc } = this.props;

        let error = null;
        switch (errorDesc) {
            case "Неверный код приватной игры":
            case "Прошедшие игры доступны только ее организатору или участнику":
                error = <PrivateGameError />;
                break;

            case "Not Found":
                error = <NotFound />;
        }

        return (
            <main className="page">
                {error ? (
                    error
                ) : (
                    <section className="card-full content">
                        <div className="card-full__head">
                            <div className="card-full__back">
                                <Link to="/" className={`icon-container`}>
                                    <Icon type={`back`} inheritColor />
                                </Link>
                            </div>
                        </div>
                        <div className="card-full__body">
                            <p className="text-center c-gs-medium-em">
                                {errorDesc ? errorDesc : "Ошибка"}
                            </p>
                        </div>
                    </section>
                )}
            </main>
        );
    };
}

GameError.propTypes = {
    errorDesc: PropTypes.bool,
    unreadNotifications: PropTypes.arrayOf(notificationsTypes),
    setNotificationsAsViewed: PropTypes.func,
};

export default GameError;
